export enum EEditor {
  DEFAULT = 'default',
  ARTICLE = 'article',
  TUTORIAL = 'tutorial',
  INLINE = 'inline',
}
